import { render } from "./barChart.vue?vue&type=template&id=5697797c"
import script from "./barChart.vue?vue&type=script&lang=js"
export * from "./barChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/statistics/barChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5697797c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5697797c', __exports__)) {
    console.log('reload')
    api.reload('5697797c', __exports__)
  }
  
  module.hot.accept("./barChart.vue?vue&type=template&id=5697797c", () => {
    console.log('re-render')
    api.rerender('5697797c', render)
  })

}


export default __exports__